import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Yo estaba completamente perdida y no sabía por dónde empezar. Aquí entendí todo paso a paso y por primera vez sentí que sí era posible. Ya tengo mi primera idea lista para lanzar.',
    name: 'Mariana R.',
    image: 'https://randomuser.me/api/portraits/women/44.jpg'
  }, {
    quote: 'Había visto mil videos y seguía confundida. Aquí te dicen exactamente qué hacer. No pierdes tiempo. Eso fue lo que marcó la diferencia para mí.',
    name: 'Laura G.',
    image: 'https://randomuser.me/api/portraits/women/68.jpg'
  }, {
    quote: 'Pensé que esto era complicado, pero está explicado tan claro que se siente posible desde el primer momento. Me dio seguridad para empezar.',
    name: 'Daniela P.',
    image: 'https://randomuser.me/api/portraits/women/65.jpg'
  }, {
    quote: 'Antes elegía productos por intuición y perdía tiempo. Con esto entendí cómo analizar bien y tomar decisiones con lógica.',
    name: 'Valentina C.',
    image: 'https://randomuser.me/api/portraits/women/33.jpg'
  }, {
    quote: 'Solo con la lista de productos ya entendí por dónde empezar. Eso para mí valió todo. Me ahorró semanas de prueba y error.',
    name: 'Karla S.',
    image: 'https://randomuser.me/api/portraits/women/47.jpg'
  }, {
    quote: 'Me gustó porque no es teoría ni relleno. Es directo, práctico y te dice exactamente qué hacer.',
    name: 'Sofía L.',
    image: 'https://randomuser.me/api/portraits/women/52.jpg'
  }, {
    quote: 'Literalmente pasé de no saber nada a tener un plan claro en pocos días. Eso no lo había logrado con nada antes.',
    name: 'Camila T.',
    image: 'https://randomuser.me/api/portraits/women/89.jpg'
  }, {
    quote: 'Sentí que por primera vez alguien explicó esto para personas normales, sin complicaciones ni palabras difíciles.',
    name: 'Paola D.',
    image: 'https://randomuser.me/api/portraits/women/26.jpg'
  }, {
    quote: 'Me ayudó a dejar de pensar tanto y empezar a actuar. Eso fue lo que más necesitaba.',
    name: 'Gabriela V.',
    image: 'https://randomuser.me/api/portraits/women/71.jpg'
  }, {
    quote: 'El checklist me dio orden total. Antes no sabía ni qué paso seguía, ahora tengo claridad completa.',
    name: 'Natalia F.',
    image: 'https://randomuser.me/api/portraits/women/57.jpg'
  }, {
    quote: 'Por este precio, todo lo que incluye es una locura. Vale muchísimo más. Es de las mejores decisiones que he tomado.',
    name: 'Jessica H.',
    image: 'https://randomuser.me/api/portraits/women/90.jpg'
  }];
  return <section className="bg-brand-white py-24 px-6" data-id="element-771">
      <div className="max-w-7xl mx-auto" data-id="element-772">
        <FadeIn data-id="element-773">
          <div className="text-center mb-16" data-id="element-774">
            <span className="text-4xl mb-4 block" data-id="element-775">💬</span>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-green uppercase tracking-wide" data-id="element-776">
              Lo que otras personas están logrando
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-777">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.05 * (index % 6)} data-id="element-778">
              <div className="bg-brand-beige/40 p-8 rounded-2xl h-full flex flex-col border border-brand-beige hover:border-brand-gold/30 transition-colors" data-id="element-779">
                <div className="flex gap-1 mb-4" data-id="element-780">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-781" />)}
                </div>
                <p className="text-brand-text/90 italic mb-6 flex-grow leading-relaxed" data-id="element-782">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-3" data-id="element-783">
                  <img src={testimonial.image} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover border-2 border-brand-beige" data-id="element-784" />
                  <p className="font-semibold text-brand-green" data-id="element-785">
                    – {testimonial.name}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}